module.exports = __webpack_public_path__ + "static/media/weekend-games.595a977b.png";